import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker,InfoWindow } from "react-google-maps"

const ContactUsMap = withScriptjs(withGoogleMap((props) =>
  
  <GoogleMap
      defaultZoom={18}
      defaultCenter={{lat:41.7105609, lng:44.7555211 }}
  >
         <Marker position={{ lat:41.7105609, lng:44.7555211 }} />

  </GoogleMap>

))

export default ContactUsMap;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactUsMap.js